export default function PagePraktisch() {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold">Praktisch</h2>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                <img 
                    src="/images\2025.05\Praktisch_Bereikbaarheid-origineel-transparant-cropped-h50.png"
                    alt="Artsenpraktijk Waarloos"
                />
                <h3 style={{ marginBottom: '0px'}}>Bereikbaarheid</h3>
            </div>
            <p>
                De praktijk is telefonisch bereikbaar op het nummer <strong>015/31.19.59</strong>:<br/>
                <ul>
                    <li>Op maandag van 8u tot 12u30 en van 13u tot 16u30 en</li>
                    <li>van dinsdag tot en met vrijdag van 8u tot 12u30.</li>
                </ul>
                Stefanie zal u dan helpen met administratieve problemen en het maken van afspraken.
            </p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                <img 
                    src="/images\2025.05\Praktisch_Bereikbaarheid2-origineel-transparant-cropped-h50.png"
                    alt="Artsenpraktijk Waarloos"
                />
                <p>
                    U kunt ons ook bereiken op ons e-mailadres <strong><a href="mailto:info@apwaarloos.be">info@apwaarloos.be</a></strong>.
                    Gelieve enkel te mailen voor korte administratieve vragen, wij trachten deze binnen de vijf werkdagen te beantwoorden.
                    Voorschriften of allerhande attesten kunnen niet via mail gevraagd worden, enkel op afspraak.
                </p>
            </div>
            <p>
                Vraag dus tijdens uw afspraak voldoende voorschriften om toe te komen tot u moet terugkomen. Ook medisch inhoudelijke vragen worden nooit via mail beantwoord.
            </p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                <img src="/images\2025.05\Praktisch_HuisBezoeken-origineel-transparant-cropped-h50.png"
                     alt="Artsenpraktijk Waarloos"/>
                <h3 style={{ marginBottom: '0px'}}>Huisbezoeken</h3>
            </div>
            <p>
                Huisbezoeken zijn voorbehouden voor mensen die zich moeilijk kunnen verplaatsen. 
                In de praktijk zijn we beter uitgerust om u verder te kunnen helpen. 
                Gelieve de huisbezoeken aan te vragen voor 10u30. Huisbezoeken moeten altijd telefonisch aangevraagd worden. 
                Voor huisbezoeken kan er geen tijdstip afgesproken worden. Huisbezoeken die de dag zelf aangevraagd worden, 
                worden ingepland bij de arts die daar die dag tijd voor heeft. U kan geen voorkeursarts opgeven
            </p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                <img src="/images\2025.05\Praktisch_Mondmaskers-origineel-transparant-cropped-h50.png"
                     alt="Artsenpraktijk Waarloos"/>
                <h3 style={{ marginBottom: '0px'}}>Mondmaskers</h3>
            </div>
            <p>
                Bij verkoudheid, griep of andere virale infecties vragen we vriendelijk om een mondmasker te dragen, ter bescherming van anderen. 
            </p>

            <h3 style={{ marginBottom: '5px'}}>Patiëntenstop</h3>
            <p>
                Bent u nieuw in onze praktijk of wil u patiënt worden in onze praktijk? Kijk dan even op <strong><a href="/nieuwepatienten/">'Nieuwe patiënten'</a></strong>.
            </p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                <img src="/images\2025.05\Praktisch_Voorschriften-origineel-transparant-cropped-h50.png"
                     alt="Artsenpraktijk Waarloos"/>
                <h3 style={{ marginBottom: '0px'}}>Voorschriften</h3>
            </div>
            <p>
                We maken genoeg voorschriften tot een nieuwe controle nodig is, maak hiervoor op tijd een afspraak.<br/>
                Al onze voorschriften worden digitaal aangemaakt. Een voorschrift is 3 maanden geldig.
                Via <strong><a href="https://voorschriftopzak.be/#/welcome">Voorschrift op Zak </a></strong> 
                of via het <a href="https://helena.care/">Helena portaal</a> kan u zien welke nog beschikbaar zijn voor u.
            </p>
            <p>Een voorschrift voor de kinesist is <strong>2 maanden</strong> geldig.</p>

            <h3 style={{ marginBottom: '5px'}}>Gemiste afspraken</h3>
            <p>
                Bij een eerste gemiste afspraak krijgt u een <strong>waarschuwing</strong>.
                <br/>
                Vanaf een tweede gemiste afspraak zal u <strong>niet meer</strong> in staat zijn om <strong>zelf afspraken te boeken</strong> via het online systeem. Er zal u ook een kost aangerekend worden van <strong>20 euro</strong>, waarvoor u geen tussenkomst van het ziekenfonds zal ontvangen.
            </p>
            <p>
                Patiënten die vaker afspraken niet nakomen zullen gevraagd worden een andere huisarts te zoeken.
                <br/>
                Op deze manier hopen we deze 'verloren' afspraken te beperken.
            </p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                <img src="/images\2025.05\Visie_Opleiding-origineel-transparant-cropped-h50.png"
                     alt="Artsenpraktijk Waarloos"/>
                <h3 style={{ marginBottom: '0px'}}>Opleidingspraktijk</h3>
            </div>
            <p>
                Dit is een opleidingspraktijk.
                Er zal dan ook steeds een huisarts in opleiding bij ons werken en regelmatig zullen er studenten geneeskunde mee de consultatie volgen.
            </p>
        </div>
    );
}
